import { DatePipe } from "@angular/common";
import { ChangeDetectorRef, Component, Inject, OnInit } from "@angular/core";
import {
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators,
} from "@angular/forms";
import { provideNativeDateAdapter } from "@angular/material/core";
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from "@angular/material/dialog";
import { Router } from "@angular/router";

import { LoadingController } from "@ionic/angular";
import { LeadActivityTypes, timeList } from "src/app/core-files/listing";
import { ToastComponent } from "src/app/core-files/loaders/toast-messages";
import { SharedService } from "src/app/core-files/shared.service.";
import { UtilityService } from "src/app/core-files/utility-services/utility.service";
import { CustomMenuService } from "src/app/services/custom-menu";
import { EncryptionService } from "src/app/services/encryption.service";
import { SharedServices } from "src/app/services/shared.service";
import { SidebarService } from "src/app/services/sidebar.service";

@Component({
  selector: "app-create-activity",
  templateUrl: "./create-activity.component.html",
  styleUrls: ["./create-activity.component.scss"],
  standalone: false
})
export class CreateActivityComponent implements OnInit {
  isActivityLoaded: boolean = false;
  registerForm: UntypedFormGroup;
  DtTime: any;
  // DtDate: string;
  DtDate: any;
  currentDate = new Date();
  minDate = new Date();
  selectedValue: any = "";
  isReschedule: boolean = false;
  isType: boolean = true;
  isAgent: boolean = this.sharedServices.isAgent();
  activityTypeList: any = [];
  customActivityTypeList: any = [];
  leadStatusList: any = [
    { id: 1, name: "Hot" },
    { id: 2, name: "Warm" },
    { id: 3, name: "Cold" },
    { id: 4, name: "Deal Close" },
  ];

  timeList: any = timeList;
  isDataLoaded: boolean = false;
  constructor(
    private _formBuilder: UntypedFormBuilder,
    private sidebarService: SidebarService,
    private datePipe: DatePipe,
    public dialogRef: MatDialogRef<"">,
    private utilityService: UtilityService,
    private sharedService: SharedService,
    public loadingController: LoadingController,
    private encryptionService: EncryptionService,
    private sharedServices: SharedServices,
    private toastComponent: ToastComponent,
    private router: Router,
    private dialog: MatDialog,
    private customMenuService: CustomMenuService,
    private cdr: ChangeDetectorRef,

    @Inject(MAT_DIALOG_DATA) public data
  ) {
    this.DtDate = new Date();
  }

  regReq = {
    CommentBox: "",
    ActivityType: "",
    LeadStatus: "",
    DtDate: "",
    DtTime: "",
    PropertyId: 0,
    UserId: parseInt(this.sharedServices.getAgentId()),
    UserName: this.sharedServices.getUserName(),
    EntryDate: new Date(),
    AgentUserId: 0,
  };
  closeDialog() {
    this.dialogRef.afterClosed().subscribe((result) => { });

    this.dialogRef.close("");
  }
  onSelectEvent(value: any) {
    this.checkType(value);
  }
  ngOnInit() {
    this.GetCustomMenuList();
    this.registerForm = this._formBuilder.group({
      CommentBox: ["", Validators.required],
      ActivityType: ["", Validators.required],
      LeadStatus: ["", Validators.required],
      DtDate: ["", Validators.required],
      DtTime: ["", Validators.required],
      UserName: [this.sharedServices.getUserName()],
      // PropertyId: 0,
    });
    this.sidebarService.GetActivityByProperty(this.data.propertyId).subscribe({
      next: (res) => {
        this.isDataLoaded = true;
        this.data.PropertyActivity = res[0];
        if (this.data.type) {
          this.regReq = {
            CommentBox: this.data.PropertyActivity.CommentBox,
            ActivityType: this.data.PropertyActivity.ActivityType,
            LeadStatus: this.data.PropertyActivity.LeadStatus,
            DtDate: this.data.PropertyActivity.DtDate,
            DtTime: this.data.PropertyActivity.DtTime,
            PropertyId: this.data.PropertyActivity.PropertyId,
            UserId: parseInt(this.sharedServices.getAgentId()),
            EntryDate: new Date(),
            AgentUserId: this.data.PropertyActivity.AgentUserId,
            UserName: this.sharedServices.getUserName(),
          };
          this.checkType(this.data.PropertyActivity.ActivityType);
        }
      },
      error: (err) => {
        this.isDataLoaded = true
      }
    });
  }

  async GetCustomMenuList() {
    const loading = await this.loadingController.create({
      cssClass: "my-custom-class",
      message: "Loading...",
    });
    await loading.present();

    this.customMenuService.GetCustomMenuList(this.sharedServices.getAgentId(), "Activity").subscribe({
      next: (res) => {
        this.customActivityTypeList = [];
        this.activityTypeList = [...LeadActivityTypes];
        this.customActivityTypeList = res;
        this.customActivityTypeList.forEach((element: any) => {
          this.activityTypeList.push({ id: this.activityTypeList.length + 1, name: element.CustomMenuTitle });
        });
        loading.dismiss();
        this.isActivityLoaded = true;
        this.cdr.detectChanges();
      },
      error: (err) => {
        console.error(err);
        loading.dismiss();
        this.isActivityLoaded = true;
        this.activityTypeList = [...LeadActivityTypes];
        this.cdr.detectChanges();
      }
    });

  }

  checkType(type: any) {
    if (
      type == "Requirement cancel" ||
      type == "Deal Closed Own" ||
      type == "Deal Closed By Other Broker" ||
      type == "Deal Closed By Direct Owner"
    ) {
      this.isType = false;
      setTimeout(() => {
        this.registerForm.controls.ActivityType.setValue(type);
        this.registerForm.controls.CommentBox.setValue(type);
        this.registerForm.controls.LeadStatus.setValue("Deal Close");
        this.registerForm.controls.DtDate.setValue(
          this.datePipe.transform(new Date(), "EEEE, MMMM d, y")
        );
        this.registerForm.controls.DtTime.setValue("11:00 PM");
      }, 100);
    } else {
      this.isType = true;
    }
  }
  goToCustomActivites(type: string) {
    this.dialogRef.close("");
    this.router.navigate(["agent-home/custom-list", this.encryptionService.encryptUsingAES256(type)]);
  }
  async attemptRegister() {
    if (this.sharedServices.isExpired()) {
      if (this.isAgent) {
        this.regReq.AgentUserId = 0;
      } else {
        this.regReq.AgentUserId = parseInt(this.sharedServices.getAgentUserId());
      }
      if (this.data.type) {
        this.regReq.DtDate = this.datePipe.transform(
          this.registerForm.value.DtDate,
          "yyyy-MM-dd"
        );
        // this.registerForm.value.PropertyId=this.data.PropertyActivity.Id;
        this.regReq.PropertyId = this.data.PropertyActivity.PropertyId;
        let userId: any = this.sharedServices.getAgentId();
        this.regReq.UserId = parseInt(userId);
        // this.regReq.DtTime='12:29:00';
        const loading = await this.loadingController.create({
          message: "Updating...",
        });
        await loading.present();
        this.sidebarService.updatePropertyActivity(this.regReq).subscribe({
          next: async (res) => {
            this.utilityService.toggleIsChangealue(true);
            this.dialogRef.close("");
            this.sharedService.setPropertyActivity(true);
            await loading.dismiss();
            this.toastComponent.showToast("Activity updated successfully", "success");
          },
          error: async (err) => {
            this.dialogRef.close("");
            await loading.dismiss();
            this.toastComponent.showToast("Failed to update activity", "danger");
          }
        });
        // this.sidebarService.createPropertyActivity(this.registerForm.value).subscribe(
        //   (res) => {
        //     this.utilityService.toggleIsChangealue(true);
        //     this.dialogRef.close("");
        //   },
        //   (err) => {
        //     this.dialogRef.close("");
        //   }
        // );
      } else {
        // this.registerForm.value.PropertyId=this.data.propertyId;

        // this.registerForm.value.DtDate='aas'
        // this.registerForm.value.DtTime='dddd';
        this.regReq.DtDate = this.datePipe.transform(
          this.registerForm.value.DtDate,
          "yyyy-MM-dd"
        );
        // this.regReq.DtDate = this.datePipe.transform(
        //   this.registerForm.value.DtDate,
        //   "EEEE, MMMM d, y"
        // );
        this.regReq.PropertyId = this.data.propertyId;
        let userId: any = this.sharedServices.getAgentId();
        this.regReq.UserId = parseInt(userId);
        (this.regReq.EntryDate = new Date());
        const loading = await this.loadingController.create({
          message: "Saving...",
        });
        await loading.present();
        this.sidebarService.createPropertyActivity(this.regReq).subscribe({
          next: async (res) => {
            this.dialogRef.close("");
            this.sharedService.setPropertyActivity(true);
            this.toastComponent.showToast("Activity created successfully", "success");
            await loading.dismiss();
          },
          error: async (err) => {
            this.dialogRef.close("");
            await loading.dismiss();
            this.toastComponent.showToast("Failed to create activity", "danger");
          }
        });
      }

    } else {
      this.dialog.closeAll();
      this.router.navigate(["agent-home/my-account/subscription"]);
    }
  }
}
